import React, {useEffect, useState} from 'react';
import axios from '../../axios';
import {toast} from "react-toastify";

const AddLabels = (props) => {

    const [labels, addlabels] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const labelsName = e => {
        console.log(e)
        const ud = Object.assign({}, labels);
        ud.name = e.target.value
        addlabels(ud);
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        if(!submitting) {
            setSubmitting(true);
        axios.post('labels', labels)
            .then(data => {
                toast.success('Label has been added successfully!')
                console.log(data);
                window.history.back();
            })
            .catch(err => {
                toast.error('Something went wrong!')
                console.log(err)
            }).finally(() => {
                setSubmitting(false);
              })}

    }

    return (
        <div className='editcities p-5 text-left'>
            <div className='row'><h1>Add labels</h1></div>
            <form onSubmit={handleSubmit}>
                <input type='text' required
                       title="This field is required" placeholder='labels Name' onChange={labelsName}></input>

                <button type='submit' className="buttonAction" disabled={submitting}>Add Label</button>
            </form>
        </div>

    )
}
export default AddLabels;
